"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var LOOSE_MATCH_BOOST = 1;
var STRICT_MATCH_BOOST = 5;
var splitWords = function (s) {
    if (s === void 0) { s = ''; }
    return s.split(/\s+/);
};
var formatItems = lodash_1.default.memoize(function (items) {
    return items.map(function (item) {
        var words = splitWords(item.name)
            .concat(item.code)
            .concat(item.alternativeSpellings || '');
        var altSpellings = item.alternativeSpellings || '';
        var matchString = lodash_1.default.trim(item.name + " " + item.code + " " + altSpellings);
        return __assign({ words: words,
            matchString: matchString }, item);
    });
});
/*
 Fuzzy search for value in items.

 Item name takes precedence, but items can have alternate spellings.
 Item code is always the first alternate spelling.

 You can force items to show up earlier in the results by giving them
 a relevancyBooster score that is greater than 0. (Or, less than 0 if
 you want have them show up later in the results.)

 Example item:

 {
   name: 'United States',
   code: 'US',
   alternativeSpellings: 'USA United States of America',
   relevancyBooster: 3.5
 }
*/
var weightedSearch = function (value, items) {
    value = lodash_1.default.trim(value);
    var formattedItems = formatItems(items);
    var parts = value.split(/\s+/);
    var regexps = lodash_1.default.map(parts, function (part) { return new RegExp(lodash_1.default.escapeRegExp(part), 'i'); });
    var strictRegexps = lodash_1.default.map(parts, function (part) { return new RegExp("^" + lodash_1.default.escapeRegExp(part), 'i'); });
    var scoredMatches = lodash_1.default.map(formattedItems, function (item) {
        var partialMatches = lodash_1.default.filter(regexps, function (re) { return re.test(item.matchString); });
        var hasStrictMatch = lodash_1.default.some(item.words, function (word) {
            return lodash_1.default.some(strictRegexps, function (re) { return re.test(word); });
        });
        if (parts.length !== partialMatches.length) {
            return __assign({ score: -1 }, item);
        }
        var boosterScore = item.relevancyBooster || 0;
        var strictScore = hasStrictMatch ? STRICT_MATCH_BOOST : 0;
        var score = partialMatches.length * LOOSE_MATCH_BOOST + boosterScore + strictScore;
        return __assign({ score: score }, item);
    });
    return scoredMatches
        .filter(function (item) { return item.score >= 0; })
        .sort(function (a, b) { return b.score - a.score; });
};
exports.default = weightedSearch;
